"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserRoles = void 0;
var _Header = _interopRequireDefault(require("../Header.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UserRoles = function UserRoles(props) {
  var isMobileView = props.isMobileView,
    user = props.user;
  var styles = (0, _Header.default)(isMobileView, !Boolean(user === null || user === void 0 ? void 0 : user.userId));
  if (!(user !== null && user !== void 0 && user.userId) || isMobileView || !(user !== null && user !== void 0 && user.schoolName)) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: styles['cc-Header__toolbar__user-role'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Header__toolbar__user-role__text'],
      children: user === null || user === void 0 ? void 0 : user.schoolName
    })
  });
};
exports.UserRoles = UserRoles;